"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "clearSuggestedActions", {
  enumerable: true,
  get: function get() {
    return _clearSuggestedActions["default"];
  }
});
Object.defineProperty(exports, "connect", {
  enumerable: true,
  get: function get() {
    return _connect["default"];
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _createStore["default"];
  }
});
Object.defineProperty(exports, "createStoreWithDevTools", {
  enumerable: true,
  get: function get() {
    return _createStore.withDevTools;
  }
});
Object.defineProperty(exports, "disconnect", {
  enumerable: true,
  get: function get() {
    return _disconnect["default"];
  }
});
Object.defineProperty(exports, "dismissNotification", {
  enumerable: true,
  get: function get() {
    return _dismissNotification["default"];
  }
});
Object.defineProperty(exports, "emitTypingIndicator", {
  enumerable: true,
  get: function get() {
    return _emitTypingIndicator["default"];
  }
});
Object.defineProperty(exports, "markActivity", {
  enumerable: true,
  get: function get() {
    return _markActivity["default"];
  }
});
Object.defineProperty(exports, "postActivity", {
  enumerable: true,
  get: function get() {
    return _postActivity["default"];
  }
});
Object.defineProperty(exports, "sendEvent", {
  enumerable: true,
  get: function get() {
    return _sendEvent["default"];
  }
});
Object.defineProperty(exports, "sendFiles", {
  enumerable: true,
  get: function get() {
    return _sendFiles["default"];
  }
});
Object.defineProperty(exports, "sendMessage", {
  enumerable: true,
  get: function get() {
    return _sendMessage["default"];
  }
});
Object.defineProperty(exports, "sendMessageBack", {
  enumerable: true,
  get: function get() {
    return _sendMessageBack["default"];
  }
});
Object.defineProperty(exports, "sendPostBack", {
  enumerable: true,
  get: function get() {
    return _sendPostBack["default"];
  }
});
Object.defineProperty(exports, "setDictateInterims", {
  enumerable: true,
  get: function get() {
    return _setDictateInterims["default"];
  }
});
Object.defineProperty(exports, "setDictateState", {
  enumerable: true,
  get: function get() {
    return _setDictateState["default"];
  }
});
Object.defineProperty(exports, "setLanguage", {
  enumerable: true,
  get: function get() {
    return _setLanguage["default"];
  }
});
Object.defineProperty(exports, "setNotification", {
  enumerable: true,
  get: function get() {
    return _setNotification["default"];
  }
});
Object.defineProperty(exports, "setSendBox", {
  enumerable: true,
  get: function get() {
    return _setSendBox["default"];
  }
});
Object.defineProperty(exports, "setSendTimeout", {
  enumerable: true,
  get: function get() {
    return _setSendTimeout["default"];
  }
});
Object.defineProperty(exports, "setSendTypingIndicator", {
  enumerable: true,
  get: function get() {
    return _setSendTypingIndicator["default"];
  }
});
Object.defineProperty(exports, "singleToArray", {
  enumerable: true,
  get: function get() {
    return _singleToArray["default"];
  }
});
Object.defineProperty(exports, "startDictate", {
  enumerable: true,
  get: function get() {
    return _startDictate["default"];
  }
});
Object.defineProperty(exports, "startSpeakingActivity", {
  enumerable: true,
  get: function get() {
    return _startSpeakingActivity["default"];
  }
});
Object.defineProperty(exports, "stopDictate", {
  enumerable: true,
  get: function get() {
    return _stopDictate["default"];
  }
});
Object.defineProperty(exports, "stopSpeakingActivity", {
  enumerable: true,
  get: function get() {
    return _stopSpeakingActivity["default"];
  }
});
Object.defineProperty(exports, "submitSendBox", {
  enumerable: true,
  get: function get() {
    return _submitSendBox["default"];
  }
});
Object.defineProperty(exports, "warnOnce", {
  enumerable: true,
  get: function get() {
    return _warnOnce["default"];
  }
});
exports.version = exports.Constants = void 0;

var ActivityClientState = _interopRequireWildcard(require("./constants/ActivityClientState"));

var DictateState = _interopRequireWildcard(require("./constants/DictateState"));

var _clearSuggestedActions = _interopRequireDefault(require("./actions/clearSuggestedActions"));

var _connect = _interopRequireDefault(require("./actions/connect"));

var _createStore = _interopRequireWildcard(require("./createStore"));

var _disconnect = _interopRequireDefault(require("./actions/disconnect"));

var _dismissNotification = _interopRequireDefault(require("./actions/dismissNotification"));

var _emitTypingIndicator = _interopRequireDefault(require("./actions/emitTypingIndicator"));

var _markActivity = _interopRequireDefault(require("./actions/markActivity"));

var _postActivity = _interopRequireDefault(require("./actions/postActivity"));

var _sendEvent = _interopRequireDefault(require("./actions/sendEvent"));

var _sendFiles = _interopRequireDefault(require("./actions/sendFiles"));

var _sendMessage = _interopRequireDefault(require("./actions/sendMessage"));

var _sendMessageBack = _interopRequireDefault(require("./actions/sendMessageBack"));

var _sendPostBack = _interopRequireDefault(require("./actions/sendPostBack"));

var _setDictateInterims = _interopRequireDefault(require("./actions/setDictateInterims"));

var _setDictateState = _interopRequireDefault(require("./actions/setDictateState"));

var _setLanguage = _interopRequireDefault(require("./actions/setLanguage"));

var _setNotification = _interopRequireDefault(require("./actions/setNotification"));

var _setSendBox = _interopRequireDefault(require("./actions/setSendBox"));

var _setSendTimeout = _interopRequireDefault(require("./actions/setSendTimeout"));

var _setSendTypingIndicator = _interopRequireDefault(require("./actions/setSendTypingIndicator"));

var _singleToArray = _interopRequireDefault(require("./utils/singleToArray"));

var _startDictate = _interopRequireDefault(require("./actions/startDictate"));

var _startSpeakingActivity = _interopRequireDefault(require("./actions/startSpeakingActivity"));

var _stopDictate = _interopRequireDefault(require("./actions/stopDictate"));

var _stopSpeakingActivity = _interopRequireDefault(require("./actions/stopSpeakingActivity"));

var _submitSendBox = _interopRequireDefault(require("./actions/submitSendBox"));

var _warnOnce = _interopRequireDefault(require("./utils/warnOnce"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Constants = {
  ActivityClientState: ActivityClientState,
  DictateState: DictateState
};
exports.Constants = Constants;
var version = "4.14.1";
exports.version = version;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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